import {
  ContractOrderOutputDto,
  OrderExternalCollaboratorOutputDto,
  UpdateContractAndAssociateExternalCostsRequest,
} from '@api/client';
import { useAppDispatch } from 'core/store/hooks';
import { searchOrders, updateOrder } from 'pages/private/passive-cycle/_redux/actions';

const useEdtitExternalCollaborators = (
  id: any,
  currentOrder: ContractOrderOutputDto | undefined,
  externalCollaborators: OrderExternalCollaboratorOutputDto[],
  setCurrentOrder: React.Dispatch<React.SetStateAction<ContractOrderOutputDto | undefined>>,
  setExternalCollaboratos: React.Dispatch<React.SetStateAction<OrderExternalCollaboratorOutputDto[]>>
) => {
  const dispatch = useAppDispatch();

  const handleSaveCollaborators = () => {
    setCurrentOrder((prev) => {
      const updatedOrder = { ...prev };
      updatedOrder.orderExternalCollaborators = externalCollaborators;
      return updatedOrder;
    });
    const payload: UpdateContractAndAssociateExternalCostsRequest = {
      createContractOrderDto: [
        {
          contractOrderId: currentOrder?.id,
          orderExternalCollaboratorInputDtos: externalCollaborators,
        },
      ],
    };
    dispatch(updateOrder(payload))
      .unwrap()
      .then((res) => {
        if (res) {
          dispatch(
            searchOrders({
              request: { contractOrderSearchDto: { orderId: Number(id), paging: { page: 0, size: 10 } } },
              currentOrderId: Number(id),
            })
          );
        }
      });
  };

  const addExternalCollaborator = () => {
    setExternalCollaboratos((prev) => [
      ...prev,
      {
        idUtenteIntranet: undefined,
        fkUtente: undefined,
        idTipologia: 3,
        idSede: currentOrder?.idSede,
        fkOrdine: currentOrder?.id,
        fkProgetto: undefined,
        fkFornitore: undefined,
        fkTipoCollaboratore: undefined,
        fkTipoContratto: undefined,
        fkTipoCompenso: undefined,
        fkTipoSpesa: undefined,
        fkTipoCompensoFornitore: undefined,
      },
    ]);
  };

  return {
    handleSaveCollaborators,
    addExternalCollaborator,
  };
};

export default useEdtitExternalCollaborators;
